import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    back: 'Back',
    deleteLogo: 'Remove logo',
    descriptionMain:
      'Your logo will no longer appear on future quotes and invoices. You can add a new one from the invoice creation page.',
    descriptionSub: 'Your existing invoices will not be modified.',
    title: 'Remove your logo',
  },
  fr: {
    back: 'Retour',
    deleteLogo: 'Supprimer le logo',
    descriptionMain:
      'Votre logo n’apparaîtra plus sur vos futurs devis et factures. Vous pouvez en ajouter un nouveau depuis la page de création de facture.',
    descriptionSub: 'Vos factures déjà enregistrées ne seront pas modifiées.',
    title: 'Suppression de votre logo',
  },
} as const);

export default locales;
